import { Box, TextField, IconButton } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../../resources/strings/StringKeys';
import COLORS from '../../../../../resources/style/Themes';
import React from 'react';

interface MessageInputProps {
  message: string;
  setMessage: (message: string) => void;
  onSend: () => void;
  isActiveEmergency: boolean;
}

const MessageInput = ({
  message,
  setMessage,
  onSend,
  isActiveEmergency,
}: MessageInputProps) => {
  const { t } = useTranslation();

  const handleSend = () => {
    if (message.trim()) {
      onSend();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      handleSend();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: COLORS.TABLE_HEADER_GRAY,
        padding: 2,
      }}
    >
      <TextField
        fullWidth
        variant="outlined"
        placeholder={
          isActiveEmergency
            ? t(StringKeys.MESSAGE)
            : t(StringKeys.EMERGENCY_HAS_BEEN_RESOLVED)
        }
        autoComplete="off"
        disabled={!isActiveEmergency}
        value={message}
        onChange={(e) => {
          setMessage(e.target.value);
        }}
        onKeyDown={handleKeyDown}
        sx={{ marginRight: 1 }}
      />
      <IconButton
        color="primary"
        onClick={handleSend}
        disabled={!isActiveEmergency}
      >
        <SendIcon />
      </IconButton>
    </Box>
  );
};

export default MessageInput;
